import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { PlaylistFooterSettings } from '@/store/playlist/types';
import { WhatsAppButton } from './WhatsAppButton';

interface PlaylistFooterProps {
  footerSettings?: PlaylistFooterSettings;
  creatorName?: string;
}

export const PlaylistFooter: React.FC<PlaylistFooterProps> = ({ 
  footerSettings,
  creatorName 
}) => {
  useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t bg-card mt-auto">
      <div className="container mx-auto px-4 py-6">
        {/* Links configurados pelo usuário */}
        <div className="flex flex-wrap items-center justify-center gap-4 text-sm">
          {footerSettings?.showTerms && footerSettings.termsUrl && (
            <a 
              href={footerSettings.termsUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              {translateInterfaceText("Termos de Uso")}</a>
          )}
          
          {footerSettings?.showPrivacy && footerSettings.privacyUrl && (
            <a 
              href={footerSettings.privacyUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              {translateInterfaceText("Política de Privacidade")}</a>
          )}
        </div>

        {/* Texto Personalizado */}
        {footerSettings?.showCustomText && footerSettings.customText && (
          <p className="text-sm text-muted-foreground text-center mt-4">
            {footerSettings.customText}
          </p>
        )}

        {/* Botão WhatsApp */}
        {footerSettings?.whatsapp?.enabled && footerSettings.whatsapp.number && (
          <div className="flex justify-center mt-4">
            <WhatsAppButton 
              number={footerSettings.whatsapp.number}
              message={footerSettings.whatsapp.message}
            />
          </div>
        )}

        {/* Criador */}
        {creatorName && (
          <p className="text-sm text-muted-foreground text-center mt-4">
            {translateInterfaceText("Criado por")}{" "}{creatorName}
          </p>
        )}
      </div>
    </footer>
  );
};
